import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        orange: '#F39200',
        orange2: '#FFF9F1',
        secondary: '#575756',
        accent: '#82B1FF',
        light: '#E3F2FD',
        error: '#DB3D50',
        error2: '#FFF1F1',
        info: '#2196F3',
        success: '#29CC39',
        success2: '#F1FFF2',
        warning: '#FFC107',
        grey:"#7C8084",
        dark: '#192028',
        borders: '#EDEDED',
        backgrounds : '#F2F2F2',
        blue: '#4572E7',
        blue2: '#EEF1F8',
        blue3: '#EEF1F8',

      },
      dark: {
        grey:"#575756",
      }
    },
  },
    lang: {
      locales: { fr },
      current: 'fr',
    },
});
